import { useBreadcrumb } from "features/breadcrumbs";
import ListarExportacaoContabil from "./components/ListarExportacaoContabil/index";

function ExportacaoContabilListagemPage() {
  useBreadcrumb([
    { name: "Financeiro" },
    { name: "Exportação Contábil", url: "/financeiro/exportacao-contabil" },
  ]);

  return <ListarExportacaoContabil />;
}

export default ExportacaoContabilListagemPage;
